import React from 'react';

import Link from '@atlaskit/link/link';

export default function Subtle(): React.JSX.Element {
	return (
		<Link href="https://www.atlassian.com/software/confluence" appearance="subtle">
			Subtle link
		</Link>
	);
}
